import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index";
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import ApiFactory from 'Api/ApiFactory';
import Axios, { AxiosStatic, CancelTokenSource } from 'axios';



interface RootSearchProductViewModel {
    MoreResults: boolean;
    NumberOfResults: number;
    Products: SearchProductViewModel[];
}

interface SearchProductViewModel {
    Id: string;
    Number: string;
    LanguageId: string;
    VariantId: string;
    Name: string;
    Link: string;
    AutoAddProductKey: AutoAddProductKey;
    QtyInBasket: number;
    UnitPrice: string;
    CurrencyCode: string;
    ThumbnailImageAltText: string;
    ThumbnailImageName: string;
}

interface AutoAddProductKey {
    ProductId: string;
    VariantId: string;
    UnitOfMeasure: string;
}



@Component({
    template: '#instant-search-template'
})
export default class InstantSearchComponent extends mixins(BaseComponent) {
    
    @Prop()
    showReset: boolean;
    
    @Prop()
    searchResultPageId: number;
    
    // The ajax uri
    @Prop()
    searchPageId: number;
    
    @Prop()
    useCurrentQueryString: boolean;
    
    // The query being searched for
    searchQuery: string = '';
    // The list of products from the api
    productList: any = null;
    // Input timeout in milliseconds
    inputTimeout: number = 200;
    // The results to get
    pageSize: string = '5';
    // Contains the state of the fold out
    foldActive: string = '';
    // The timeout currently being performed
    timeout: number;
    // Loader
    queryLoading: boolean = false;
    // Cancel request
    cancelSource: CancelTokenSource = null;
    // Primary photo key
    primaryPictureKey: string = 'Primærfoto';
    
    formref: HTMLFormElement;
    
    searchqueryRef: HTMLInputElement;
    
    response: RootSearchProductViewModel = null;
    
    async mounted(){
        this.formref = <HTMLFormElement>this.$refs.formref;
        this.searchqueryRef = <HTMLInputElement> this.$refs.searchqueryRef;
        // this.formref.onsubmit = (ev : Event) => {
        //     this.formref.
        // };
        
    }
    
    
    get isDisabled(): boolean{
        return this.searchQuery.length == 0;
    }

    get numberOfResults(){
        return this.response?.NumberOfResults;
    }

    get moreResults() : boolean{
        return this.response?.MoreResults; 
    }
    
    resetSearchQuery(event: any): void{
        this.searchqueryRef.value = null;
        this.formref.submit();
    }
    
    onSubmit(){
        if(!this.isDisabled) this.formref.submit();
    }
    
    inputChanged(event: any) {
        this.queryLoading = true;
        
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.callApi(event.target.value);
        }, this.inputTimeout);
    }
    
    closeFoldOut() {
        this.foldActive = null;
    }
    
    getCurrentQueryString(): any{
        if(this.useCurrentQueryString)
        {
            const urlParams = new URLSearchParams(window.location.search?.toLowerCase());
            urlParams.delete('id');
            urlParams.delete('ecomquery');
            urlParams.delete('pagenum');
            return urlParams.entries();
        }
        
        return [];
    }
    
    getPrimaryPhoto(specifications: any, defaultImage: string) {
        for (let i = 0; i < specifications.length; i++) {
            if (specifications[i].Key === this.primaryPictureKey) {
                return specifications[i].Value;
            }
        }
        
        return defaultImage;
    }
    
    getProductUrl(product: SearchProductViewModel) {
        const urlParams = new URLSearchParams(window.location.search);
        
        // if (product.ProductReplacementIds != null && product.ProductReplacementIds.includes(urlParams.get("searchquery"))) {
        //     let productUrl = window.location.origin + product.Url;
        //     const url = new URL(productUrl);
        //     url.searchParams.set('isReplacementSearch', 'true');
        
        //     return url.href;
        // }
        
        return product.Link;
    }
    
    async callApi(search: string) {
        if (this.cancelSource) {
            this.cancelSource.cancel();
        }
        
        this.searchQuery = search.trim();
        
        if (this.searchQuery.length === 0) {
            this.productList = null;
            this.queryLoading = false;
            return;
        }
        
        const  url = 'default.aspx?ID={0}'.replace('{0}', this.searchPageId+'');
        
        const params = <any>{};
        
        params['ecomQuery'] = search;
        
        if(this.useCurrentQueryString)
        {
            for(let param of this.getCurrentQueryString()){
                params[param[0]] = param[1];
            }
        }
        
        
        const cancelToken = Axios.CancelToken;
        this.cancelSource = cancelToken.source();
        const response = await ApiFactory.searchProducts(url, params, this.cancelSource.token);
        
        const data = <RootSearchProductViewModel>response.data;
        this.response = data;
        this.productList = data.Products;
        this.queryLoading = false;
        
        // const uri = new URL(this.ajaxUri, window.location.origin);
        // uri.searchParams.set('searchquery', this.searchQuery);
        // uri.searchParams.set('Json', 'true');
        // uri.searchParams.set('PageSize', this.pageSize);
        
        // const CancelToken = axios.CancelToken;
        // this.cancelSource = CancelToken.source();
        
        // axios.get(uri.href, { cancelToken: this.cancelSource.token }).then(
        //     (response: AxiosResponse<ProductListPage>) => {
        //         this.productList = response.data.Products.length > 0 ? response.data.Products : null;
        //         this.queryLoading = false;
        //         this.cancelSource = null;
        //     });
    }
}

Vue.component('instant-search', InstantSearchComponent);